import { BlurBackgroundDivFixed } from 'crono-fe-common/components/Layout/BlurBackgroundDiv';
import AiAssistantForm, { IPropsAiAssistantForm } from '.';
import { colors } from 'crono-fe-common/theme';
import { Typography } from '@mui/material';
import {
  CancelButton,
  MainButton,
} from 'crono-fe-common/components/CronoButton';

const AiAssistantFormModal = ({
  close,
  save,
  ...props
}: IPropsAiAssistantForm & {
  close: () => void;
  save: () => void;
}) => {
  const isDataPresent = [
    props.toneOfVoice,
    props.productDescription,
    props.audience,
    props.challenges?.length,
    props.hows?.length,
  ].every(Boolean);

  return (
    <BlurBackgroundDivFixed
      style={{
        zIndex: 35002,
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          background: colors.white,
          borderRadius: 16,
          overflow: 'hidden',
          border: `1px solid ${colors.grey444}`,
          maxHeight: '90%',
          padding: 48,
          gap: 24,
          maxWidth: 'min(calc(100% - 110px), 600px)',
          width: '100%',
        }}
      >
        <Typography fontSize={24} lineHeight={'30px'} fontWeight={700}>
          Product info
        </Typography>

        <AiAssistantForm
          {...props}
          styleProps={{
            maxWidth: '100%',
          }}
          isEditView={true}
        />
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            justifyContent: 'flex-end',
            gap: 8,
          }}
        >
          <CancelButton
            style={{
              margin: 0,
              width: 120,
            }}
            onClick={close}
          >
            Cancel
          </CancelButton>
          <MainButton
            style={{
              margin: 0,
              width: 120,
            }}
            disabled={!isDataPresent}
            onClick={save}
          >
            Save
          </MainButton>
        </div>
      </div>
    </BlurBackgroundDivFixed>
  );
};

export default AiAssistantFormModal;
